import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initAnalytics, pageview } from "@/lib/analytics";

import LandingPage from "@/pages/LandingPage";
import ChatPage from "@/pages/ChatPage";
import DeadlinesPage from "@/pages/DeadlinesPage";
import EstimatorPage from "@/pages/EstimatorPage";
import DecoderPage from "@/pages/DecoderPage";
import ComparePage from "@/pages/ComparePage";
import ScholarshipsPage from "@/pages/ScholarshipsPage";
import AppealPage from "@/pages/AppealPage";
import LoansPage from "@/pages/LoansPage";
import GlossaryPage from "@/pages/GlossaryPage";
import JourneyPage from "@/pages/JourneyPage";
import SideBySidePage from "@/pages/SideBySidePage";
import NetPricePage from "@/pages/NetPricePage";
import FindSchoolsPage from "@/pages/FindSchoolsPage";
import CounselorPage from "@/pages/CounselorPage";
import { PrivacyPage, TermsPage } from "@/pages/LegalPages";
import ScrollToTop from "@/components/ScrollToTop";

// New agentic features — public, no auth, additive routes only
import AppDashboardPage from "@/pages/app/DashboardPage";
import AppCalendarPage from "@/pages/app/CalendarPage";
import AppFafsaPage from "@/pages/app/FafsaPage";
import AppMoneySaverPage from "@/pages/app/MoneySaverPage";
import AppDreamSchoolPage from "@/pages/app/DreamSchoolPage";
import AppSaverSharePage from "@/pages/app/SaverSharePage";

function Tracker() {
  const loc = useLocation();
  useEffect(() => { pageview(loc.pathname); }, [loc.pathname]);
  return null;
}

function AppRouter() {
  return (
    <>
      <ScrollToTop />
      <Tracker />
      <Routes>
        {/* Existing site (unchanged) */}
        <Route path="/"             element={<LandingPage />} />
        <Route path="/chat"         element={<ChatPage />} />
        <Route path="/deadlines"    element={<DeadlinesPage />} />
        <Route path="/estimator"    element={<EstimatorPage />} />
        <Route path="/decoder"      element={<DecoderPage />} />
        <Route path="/compare"      element={<ComparePage />} />
        <Route path="/scholarships" element={<ScholarshipsPage />} />
        <Route path="/appeal"       element={<AppealPage />} />
        <Route path="/loans"        element={<LoansPage />} />
        <Route path="/glossary"     element={<GlossaryPage />} />
        <Route path="/journey"      element={<JourneyPage />} />
        <Route path="/sidebyside"   element={<SideBySidePage />} />
        <Route path="/netprice"     element={<NetPricePage />} />
        <Route path="/find"          element={<FindSchoolsPage />} />
        <Route path="/affordability" element={<FindSchoolsPage />} />
        <Route path="/hidden-gems"   element={<FindSchoolsPage />} />
        <Route path="/counselor"    element={<CounselorPage />} />
        <Route path="/legal/privacy" element={<PrivacyPage />} />
        <Route path="/legal/terms"   element={<TermsPage />} />

        {/* New agentic layer — fully public, additive */}
        <Route path="/app"              element={<AppDashboardPage />} />
        <Route path="/app/dashboard"    element={<AppDashboardPage />} />
        <Route path="/app/calendar"     element={<AppCalendarPage />} />
        <Route path="/app/fafsa"        element={<AppFafsaPage />} />
        <Route path="/app/saver"        element={<AppMoneySaverPage />} />
        <Route path="/app/saver/share"  element={<AppSaverSharePage />} />
        <Route path="/app/dream-school" element={<AppDreamSchoolPage />} />

        <Route path="*" element={<LandingPage />} />
      </Routes>
    </>
  );
}

export default function App() {
  useEffect(() => { initAnalytics(); }, []);
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}
